module.exports = "<p>\r\n  product-likes works!\r\n</p>\r\n"